import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { CreditCard, X } from "lucide-react";

const money = (m) => `GBP ${(((m || 0) / 100)).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Part 7: the user paying KADANA for credits. Explicitly distinct from Part 5 (the user's own app
// taking payments from its own customers). Hands off to the existing Stripe billing integration.
export default function CreditsDialog({ open, onClose }) {
  const [tiers, setTiers] = useState([]);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    if (open) api.get("/pricing").then((r) => setTiers(r.data.top_up_tiers || [])).catch(() => {});
  }, [open]);

  if (!open) return null;

  const buy = async (t) => {
    setBusy(t.label);
    try {
      const { data } = await api.post("/billing/checkout", { kind: `topup:${t.label}`, currency: "GBP" });
      if (data.status === "sandbox") toast.success(data.message || `SANDBOX: ${data.granted_credits} credits granted`);
      else if (data.checkout_url) window.location.href = data.checkout_url;
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(""); }
  };

  return (
    <div data-testid="credits-dialog" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100 }} onClick={onClose}>
      <div className="k-container" style={{ padding: 24, maxWidth: 460, width: "90%" }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 className="k-heading" style={{ fontSize: 18, margin: 0, display: "flex", alignItems: "center", gap: 8 }}><CreditCard size={18} /> Buy credits</h3>
          <button className="k-btn k-btn-ghost" data-testid="credits-close" onClick={onClose} style={{ padding: 6 }}><X size={16} /></button>
        </div>
        <p className="k-muted" style={{ fontSize: 13 }}>This is <strong>you paying Kadana</strong> for build credits. It is not the same as connecting a payment provider for your own app to take payments — that lives in the Manage tab.</p>
        <div style={{ display: "grid", gap: 10, marginTop: 8 }}>
          {tiers.map((t) => (
            <div key={t.label} data-testid={`credit-tier-${t.label}`} className="k-container" style={{ padding: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <strong>{t.label}</strong>
                <div className="k-muted" style={{ fontSize: 13 }}>{t.credits_granted} credits · {money(t.price_minor_units)}</div>
              </div>
              <button className="k-btn k-btn-primary" data-testid={`credit-buy-${t.label}`} disabled={busy === t.label} onClick={() => buy(t)}>{busy === t.label ? "…" : "Buy"}</button>
            </div>
          ))}
        </div>
        <p className="k-muted" style={{ fontSize: 11, marginTop: 12 }}>Checkout runs through Stripe. Test key active → SANDBOX (no real charge).</p>
      </div>
    </div>
  );
}
